module.exports = "/packs/images/svg/arrow_left~556583e37dd925cc84e10070ad55d7cf.svg";